export default "__VITE_ASSET__KLXZJJBs__"